import PropTypes from 'prop-types'
import React     from 'react'

import { NavLink               } from 'alto-react-components/lib/components'
import { prefix as authPrefix  } from 'alto-react-base-auth/lib/routes'
import { profile               } from 'alto-react-client-auth/lib/routes'
import { generalProfileSetting } from 'alto-react-client-auth/lib/settings'
import { terminalLoginSetting  } from './settings'

export prefix                = '/canteen'
export menu                  = prefix + '/menu'
export canteenManagement     = prefix + '/canteen_management'
export courseGroupManagement = prefix + '/course_group_management'
export courseManagement      = prefix + '/course_management'
export mealManagement        = prefix + '/meal_management'
export orderManagement       = prefix + '/order_management'
export terminalManagement    = prefix + '/terminal_management'
export canteenLogin          = authPrefix + '/login'
export webLogin              = authPrefix + '/login/web'
export terminalLogin         = authPrefix + '/login/terminal'

export CanteenProfileNavLink = (props, context) ->
  profileSetting     = generalProfileSetting(context.settings)
  profileEditAllowed = (profileSetting.enabled and context.auth.isClient and
                        not context.auth.isTerminal)
  profileCaption     = if profileEditAllowed then 'Profil' else 'Změnit heslo'

  <NavLink id="profile-link" to={profile}>{profileCaption}</NavLink>

CanteenProfileNavLink.contextTypes = { auth: PropTypes.object, settings: PropTypes.object }

export TerminalManagementNavLink = (props, context) ->
  setting = terminalLoginSetting(context.settings)

  if setting.enabled
    <NavLink to={terminalManagement}>Terminály</NavLink>
  else null

TerminalManagementNavLink.contextTypes = { settings: PropTypes.object }
